import React, { useCallback, useRef, useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import html2canvas from "html2canvas";
import "./PitchDownloadModal.css"; // Import the CSS file
import { Link } from "react-router-dom";

const PitchDownloadModal = (props) => {
  const modalContentRef1 = useRef(null);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [imageLoadCount, setImageLoadCount] = useState(0);

  const captureImage = useCallback(() => {
    const targetElement = modalContentRef1.current;
    if (targetElement) {
      html2canvas(targetElement, { useCORS: true }).then((canvas) => {
        const image = canvas.toDataURL("image/png");

        // Create a download link
        const downloadLink = document.createElement("a");
        downloadLink.href = image;
        downloadLink.download = `MyClubtap-Pitch`;

        // Append the link to the document and trigger a click event
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Remove the link from the document
        document.body.removeChild(downloadLink);
      });
    }
  }, []);

  const { loadingStates, handlePitchCardModalClose } = props;

  const handleModalEntered = useCallback(() => {
    if (loadingStates["pitch_card"] === false) {
      captureImage();
      handlePitchCardModalClose();
    }
  }, [loadingStates, captureImage, handlePitchCardModalClose]);

  useEffect(() => {
    if (modalContentRef1.current) {
      const images = modalContentRef1.current.querySelectorAll("img");
      const totalImages = images.length;
      let loadedCount = 0;

      images.forEach((img) => {
        img.onload = () => {
          loadedCount++;
          setImageLoadCount(loadedCount);
          if (loadedCount === totalImages) {
            setImagesLoaded(true);
          }
        };
      });
    }
  }, []);

  //   useEffect(() => {
  //     if (imageLoadCount > 0) {
  //       console.log(`Loaded ${imageLoadCount} images`);
  //     }
  //   }, [imageLoadCount]);

  const showPlayerPts = (pts) => {
    if (pts) {
      return pts;
    }
    return 0;
  };

  return (
    <>
      <Modal
        show={props.showPitchCardModal}
        onHide={() => props.setShowPitchCardModal(false)}
        size="lg"
        id="playermoreinfo1"
        onEntered={handleModalEntered}
        dialogClassName="custom-modal-content"
      >
        <div ref={modalContentRef1}>
          <div className="groundview1">
            <div className="ground">
              <div className="sponsorlogo">
                <figure className="small-logo">
                  <img
                    src="images/small-brand-logo.jpg"
                    alt="img"
                    onLoad={() => setImageLoadCount((count) => count + 1)}
                  />
                </figure>
                <figure className="big-logo">
                  <img
                    src="images/big-brand-logo.png"
                    alt="img"
                    onLoad={() => setImageLoadCount((count) => count + 1)}
                  />
                </figure>
              </div>
              <figure className="groundbg">
                <img
                  src="images/groundbgnew.png"
                  alt="img"
                  onLoad={() => setImageLoadCount((count) => count + 1)}
                />
              </figure>
              <div className="team-fieldview">
                <ul className="wk_profile">
                  {props.playerList &&
                    props.playerList
                      .filter((playerData1) => playerData1?.position === 4)
                      .map((data, key) => (
                        <li key={key}>
                          <figure>
                            <Link to={`/player-profile/${data?.id}`}>
                              {data?.is_avatar === 1 ? (
                                <img
                                  src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${data?.image}`}
                                  alt="img"
                                  onLoad={() =>
                                    setImageLoadCount((count) => count + 1)
                                  }
                                />
                              ) : (
                                <img
                                  src={`${process.env.REACT_APP_UPLOAD_URL}player/${data?.image}`}
                                  alt="img"
                                  onLoad={() =>
                                    setImageLoadCount((count) => count + 1)
                                  }
                                />
                              )}
                            </Link>
                          </figure>
                          <div className="pitchplayer">
                            <h5>
                              <span className="available"></span>
                              {data?.full_name?.substring(0, 8) + ".."}
                            </h5>
                            <span>
                              {data?.position_name},{" "}
                              {showPlayerPts(props.playerPoints?.[data?.id])}
                            </span>
                          </div>
                          {props.capId === data?.id && (
                            <a href="0" className="captain captionoption">
                              C
                            </a>
                          )}
                          {props.viceCapId === data?.id && (
                            <a href="0" className="vicecaptain captionoption">
                              VC
                            </a>
                          )}
                        </li>
                      ))}
                </ul>

                <ul className="bat_profile">
                  {props.playerList &&
                    props.playerList
                      .filter((playerData1) => playerData1?.position === 1)
                      .map((data, key) => (
                        <li key={key}>
                          <figure>
                            <Link to={`/player-profile/${data?.id}`}>
                              {data?.is_avatar === 1 ? (
                                <img
                                  src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${data?.image}`}
                                  alt="img"
                                  onLoad={() =>
                                    setImageLoadCount((count) => count + 1)
                                  }
                                />
                              ) : (
                                <img
                                  src={`${process.env.REACT_APP_UPLOAD_URL}player/${data?.image}`}
                                  alt="img"
                                  onLoad={() =>
                                    setImageLoadCount((count) => count + 1)
                                  }
                                />
                              )}
                            </Link>
                          </figure>
                          <div className="pitchplayer">
                            <h5>
                              <span className="available"></span>
                              {data?.full_name?.substring(0, 8) + ".."}
                            </h5>
                            <span>
                              {data?.position_name},{" "}
                              {showPlayerPts(props.playerPoints?.[data?.id])}
                            </span>
                          </div>
                          {props.capId === data?.id && (
                            <a href="0" className="captain captionoption">
                              C
                            </a>
                          )}
                          {props.viceCapId === data?.id && (
                            <a href="0" className="vicecaptain captionoption">
                              VC
                            </a>
                          )}
                        </li>
                      ))}
                </ul>
                <ul className="ar_profile">
                  {props.playerList &&
                    props.playerList
                      .filter((playerData1) => playerData1?.position === 3)
                      .map((data, key) => (
                        <li key={key}>
                          <figure>
                            <Link to={`/player-profile/${data?.id}`}>
                              {data?.is_avatar === 1 ? (
                                <img
                                  src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${data?.image}`}
                                  alt="img"
                                  onLoad={() =>
                                    setImageLoadCount((count) => count + 1)
                                  }
                                />
                              ) : (
                                <img
                                  src={`${process.env.REACT_APP_UPLOAD_URL}player/${data?.image}`}
                                  alt="img"
                                  onLoad={() =>
                                    setImageLoadCount((count) => count + 1)
                                  }
                                />
                              )}
                            </Link>
                          </figure>
                          <div className="pitchplayer">
                            <h5>
                              <span className="available"></span>
                              {data?.full_name?.substring(0, 8) + ".."}
                            </h5>
                            <span>
                              {data?.position_name},{" "}
                              {showPlayerPts(props.playerPoints?.[data?.id])}
                            </span>
                          </div>
                          {props.capId === data?.id && (
                            <a href="0" className="captain captionoption">
                              C
                            </a>
                          )}
                          {props.viceCapId === data?.id && (
                            <a href="0" className="vicecaptain captionoption">
                              VC
                            </a>
                          )}
                        </li>
                      ))}
                </ul>
                <ul className="bowl_profile">
                  {props.playerList &&
                    props.playerList
                      .filter((playerData1) => playerData1?.position === 2)
                      .map((data, key) => (
                        <li key={key}>
                          <figure>
                            <Link to={`/player-profile/${data?.id}`}>
                              {data?.is_avatar === 1 ? (
                                <img
                                  src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${data?.image}`}
                                  alt="img"
                                  onLoad={() =>
                                    setImageLoadCount((count) => count + 1)
                                  }
                                />
                              ) : (
                                <img
                                  src={`${process.env.REACT_APP_UPLOAD_URL}player/${data?.image}`}
                                  alt="img"
                                  onLoad={() =>
                                    setImageLoadCount((count) => count + 1)
                                  }
                                />
                              )}
                            </Link>
                          </figure>
                          <div className="pitchplayer">
                            <h5>
                              <span className="available"></span>
                              {data?.full_name?.substring(0, 8) + ".."}
                            </h5>
                            <span>
                              {data?.position_name},{" "}
                              {showPlayerPts(props.playerPoints?.[data?.id])}
                            </span>
                          </div>
                          {props.capId === data?.id && (
                            <a href="0" className="captain captionoption">
                              C
                            </a>
                          )}
                          {props.viceCapId === data?.id && (
                            <a href="0" className="vicecaptain captionoption">
                              VC
                            </a>
                          )}
                        </li>
                      ))}
                </ul>
              </div>
              <div className="powerbtn powerbtn-box">
                <div className="leadertag">
                  <h5 className="captaintag">
                    <strong>
                      {props?.userDetails?.full_name} |{" "}
                      {props.pitchModalData?.my_team_name}
                    </strong>
                  </h5>
                  <h5 className="vicecaptaintag">
                    <strong>
                      Rank: {props.roundData?.overall_rank} | Points:{" "}
                      {props?.ovrPts}
                    </strong>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PitchDownloadModal;
